// @flow
import * as React from 'react';

import type { Element } from 'react';
import handleViewport from 'react-in-viewport/dist';
import type { Props, State } from './types';


import {
  StyledCover,
  StyledImageCover,
  StyledImageContainer,
  StyledCopy,
  StyledCopyHeadlineText,
  StyledCopyText,
} from './styles';

const width = 380;
const height = 275;
// const offsetSlope = 50;

// const pathNoMask = `
//   M0,0
//   L${width},0
//   L${width},${height}
//   L0,${height}
//   L0,0`;
// const pathMaskRightT2B = `
//   M0,0
//   L${width},0
//   L${width - offsetSlope},${height}
//   L0,${height}
//   L0,0`;
// const pathMaskLeftT2B = `
//   M0,0
//   L${width},0
//   L${width},${height}
//   L${offsetSlope},${height}
//   L0,0`;
// const pathMaskLeftB2T = `
//   M${offsetSlope},0
//   L${width},0
//   L${width},${height}
//   L0,${height}
//   L${offsetSlope},0`;
// const pathMaskLeftB2TRightT2B = `
//   M${offsetSlope},0
//   L${width},0
//   L${width - offsetSlope},${height}
//   L0,${height}
//   L${offsetSlope},0`;

const ViewportStyledImageContainer = handleViewport(
  StyledImageContainer,
  {
    root: null,
    rootMargin: '0%',
    threshold: [0.1]
  },
  { disconnectOnLeave: true }
);

class TeaserImageCopy extends React.Component<Props, State> {
  static defaultProps = {
    index: 0
  };

  constructor(props: Props) {
    super(props);
    this.state = { animate: false };
  }

  handleEnterViewport = () => {
    this.setState({ animate: true });
  };

  render(): Element<any> {
    const {
      imageUrl, headline, copy, index, disableAnimations, imgix
    }: Props = this.props;
    const { animate: animateState }: State = this.state;
    const animate = disableAnimations ? false : animateState;

    // const id = Buffer.from(imageUrl).toString('base64');

    return (
      <StyledCover>
        <ViewportStyledImageContainer onEnterViewport={this.handleEnterViewport}>
          <StyledImageContainer
            index={index}
            imgix={imgix}
            animate={animate}
            forceVisible={!!disableAnimations}
          >
            <StyledImageCover imgix={imgix}>
              <img src={imageUrl} x="0" y="0" width={width} height={height} alt="HowItWorks" />
            </StyledImageCover>
          </StyledImageContainer>
        </ViewportStyledImageContainer>

        <StyledCopy>
          <StyledCopyHeadlineText>{headline}</StyledCopyHeadlineText>
          <StyledCopyText>{copy}</StyledCopyText>
        </StyledCopy>
      </StyledCover>
    );
  }
}

export default TeaserImageCopy;
